import { set } from 'lodash';
import { MutationTree } from 'vuex';
import { ownedByAsaren } from '~/pages/360/acl';

export const state = () => ({
  id: null,
  query: {
    where: {
      reportType: ['DNA_360'],
      dnaPanel: [],
      dnaCategory: [],
      dnaSubCategory: [],
      dnaTrait: [],
      reversedScore: [],
      dnaScoreType: [],
      ownedByAsaren,
      sex: [],
      vendorBioItIds: []
    },
    sort: {
      bioinformaticPanel: 'DESC'
    },
    offset: 0,
    limit: 10
  },
  table: {
    footer: {
      'items-per-page-options': [10, 25, 50, 100],
      'show-current-page': true,
      'show-first-last-page': true,
      'page-text': '{{pageStart}}',
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['bioinformaticPanel'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      }
    },
    filter: {
      keyword: '',
      reportType: ['DNA_360'],
      ownedByAsaren,
      dnaPanel: [],
      dnaCategory: [],
      dnaSubCategory: [],
      dnaTrait: [],
      dnaScoreType: [],
      reversedScore: null,
      sex: null,
      vendorBioItIds: []
    },
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['bioinformaticPanel'],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: true
    }
  }
});

export type DNA360Mapper = ReturnType<typeof state>;

export const mutations: MutationTree<DNA360Mapper> = {
  changeId: (state, id) => (state.id = id),
  changeQuery: (state, query) => Object.assign(state.query, query),
  changeTableFilter: (state, filter) => {
    Object.assign(state.table, { filter });
    Object.assign(state.query.where, {
      keyword: filter.keyword,
      reportType: filter.reportType,
      ownedByAsaren,
      dnaPanel: filter.dnaPanel,
      dnaCategory: filter.dnaCategory,
      dnaSubCategory: filter.dnaSubCategory,
      dnaTrait: filter.dnaTrait,
      dnaScoreType: filter.dnaScoreType,
      reversedScore: filter.reversedScore,
      sex: filter.sex,
      vendorBioItIds: filter.vendorBioItIds
    });
  },
  changeTableOptions: (state, options) => {
    Object.assign(state.table, { options });
    Object.assign(state.table.footer, { options });
    Object.assign(state.query, {
      sort: set({}, options.sortBy[0], options.sortDesc[0] ? 'DESC' : 'ASC'),
      limit: options.itemsPerPage,
      offset: (options.page - 1) * options.itemsPerPage
    });
  }
};
